import React from 'react';

const ViewportMeta = () => (
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
);

export default ViewportMeta;
